/*jslint browser: true */
/*global window */

(function($){

/* Form functions */

// Switch between main screens
$(document).on('click', '.screenSwitch', function(){
	let whichScreen = $(this).data('switch-screen')
	if (whichScreen == "none") return
	$('.bookform-section').hide()
	$('[data-section="' + whichScreen + '"]').show()
	window.history.replaceState(null, null, "?screen=" + whichScreen);

	// Get current screen and pass info to back button and create history
	let prevScreen = $(this).parent().closest('.bookform-section')
	let prevID = prevScreen.data('section')

	$('#fq_current_screen').val(whichScreen)
	let historyRecords = $('.bookform-section-' + whichScreen + ' .screenSwitch')
	historyRecords.each(function(){
		$(this).data('prev-screen', prevID)
	})

	// Show button after screen 1
	$('#backButton').data('switch-screen', prevID)
	if (whichScreen > "1") {
		$('#backButton').show()
	}
})

$(document).on('click', '.backButton', function(){
	let currScreen = $('#fq_current_screen').val()
	let prevID = $('.bookform-section-' + currScreen + ' .screenSwitch').data('prev-screen')
	
	$('#backButton').data('switch-screen', prevID)


	$('.bookform-section').hide()
	$('[data-section="' + prevID + '"]').show()
	window.history.replaceState(null, null, "?screen=" + prevID);
	$('#fq_current_screen').val(prevID)
	// Hide button on screen 1
	if (prevID == "1") {
		$(this).hide()
	}
})


// Add which screen to progress button
$(document).on('click', '.screenSetup', function(){
	let whichScreen = $(this).data('switch-step')
	let whichButton = $(this).data('which-button')
	$('.progButton[data-prog-button="' + whichButton + '"]').data('switch-screen', whichScreen)
})


// Switch between sub screens 
$(document).on('click', '.subScreenSwitch', function(){
	// Show sections
	let whichScreen = $(this).data('reveal-step')
	let whichSplit = whichScreen.split(",")
	for (var i = whichSplit.length - 1; i >= 0; i--) {
		$('[data-subsection="' + whichSplit[i] + '"]').show()
	}

	// Hide sections
	let hideScreen = $(this).data('hide-step')
	let hideSplit = hideScreen.split(",")
	for (var p = hideSplit.length - 1; p >= 0; p--) {
		$('[data-subsection="' + hideSplit[p] + '"]').hide()
	}	
})


// Update hidden fields with data
$(document).on('keydown blur', '.updateField', function(){
	let which_input = $(this).data('which-input')
	let currentInput = $(this).val()
	$('#' + which_input).val( currentInput )
	if (which_input == "fq_user_name") {
		let nameSwitch = $('.custName')
		nameSwitch.each(function(){
			$(this).text(currentInput)
		})
	}
})

// Change Stage 3 label depending on if the user lives alone
$('[data-change-label]').on('click', function(){
	let whichLabel = $(this).data('change-label')
	$('[data-label]').hide()
	$('[data-label="' + whichLabel + '"]').show()
})


$("[data-on-behalf]").on('click', function(){
	let onBehalf = $(this).data('on-behalf')
	$('#fq_someone_else').val(onBehalf)
	// Validate fields
	if (onBehalf == "1") {
		validateFields(1)
		clearValidation(2)
	} else if (onBehalf == "2") {
		validateFields(2)
		clearValidation(1)
	}
})




// Data Validation
function validateFields(validate) {
	let valInputs = $('[data-validate-block="' + validate + '"] input')
	valInputs.each(function(i, e){
		$(this).prop('required',true);
	})
}
function clearValidation(validate) {
	let valInputs = $('[data-validate-block="' + validate + '"] input')
	valInputs.each(function(i, e){
		$(this).prop('required',false);
	})
}




// Translate functions

$('.header-translate').on('click', function(){
	$('.header-translate-dropdown').toggleClass('open')
})

	
setTimeout(function(){
	let dropdowns = $('.header-translate-dropdown a')
	dropdowns.each(function(){
		$(this).attr('tabindex', '-1')
	})
}, 500)


// Brochure popup
$('.openPopup').on('click', function(){
	$('.popUp').show()
})
$('.closePopup').on('click', function(){
	$('.popUp').hide()
})

})(jQuery);